<template>
  <div>
    <oil-form v-if='loading'
              :title='title'
              :items='invoice'
              :createForm='!id'
              :keys='keys'
              :formCallback='formCallback'
              @ImporterId='changeImporter'
              @ProductId='changeProduct'
    >
      <template v-slot:File='{input}'>
        <v-file-input
            @change='file'
            :disabled='!input.isEdit'
            :label='label'
            outlined
            dense
        />
      </template>

      <template v-slot:Download='{input}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn style='box-shadow: none;color: #00b24f;background-color: transparent' :disabled='!input.isEdit'
                   @click='dow(invoice)'
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Скачать</span>
        </v-tooltip>
      </template>

    </oil-form>
  </div>
</template>

<script>
import keys from './setting/invoice.json'
import { coreApi } from '~/services/core'
import { productsService } from '@/services/ProductsService'
import { num2str } from '~/utils/functions/MoneyFromString'
import { fileService } from '~/services/FileNextNumberService'

export default {
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    DatePicker: () => import('@/components/helper/form/oil.date.picker')
  },
  props: {
    id: String
  },
  data() {
    return {
      loading: false,
      title: 'Создать Инвойс',
      invoice: {
        Importer: {},
        Attachment: {},
        Product: {},
        File: {},
        Number: '',
        UsDollarRate: '',
        StartDate: '',
        QuantityTons: '',
        PricePerTon: '',
        TotalUs: '',
        TotalUsWords: '',
        Comment: ''
      },
      importers: [],
      products: [],
      keys: keys,
      label: 'загрузить файл'
    }
  },
  async created() {
    const importers = await coreApi.get('importer')
    this.importers = importers.data || []
    const products = await productsService.getAll()
    this.products = products.data || []

    if (this.id) {
      this.title = 'Инфо о Инвойсе'
      const invoice = await coreApi.get(`importer-invoice?id=${this.id}`)
      this.label = invoice.data?.Attachment?.Name || 'загрузить файл'
      if (invoice.data) {
        this.invoice = invoice.data
      }
    }
    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? coreApi.put : coreApi.post
    },
    message() {
      return this.id ? 'инвойс удачно изменен' : 'инвойс удачно создан'
    }
  },
  methods: {
    test(number) {
    },
    async formCallback(data, input, form, func) {
      input.isEdit = false

      const response = await this.storeType('importer-invoice', data)

      if (!response.data) {
        input.isEdit = true
      }

      this.invoice = response.data

      func(this.message)

      if (!this.id) {
        await this.$router.push({
          name: 'importer-invoice',
          params: { id: this.invoice.Id }
        })
      }
    },
    changeProduct(product) {
      if (!product) return
      this.invoice.Product = { ...product }
    },
    changeImporter(importer) {
      if (!importer) return
      this.invoice.Importer = { ...importer }
    },
    async file(file) {
      const fileId = await fileService.generateId()
      const res = await fileService.upload(fileId.data.Id, file)
      this.invoice.Attachment = res.data || {}

      // if (!(file instanceof File)) return
      //
      // const arrayPromise = new Promise(function(resolve) {
      //   const reader = new FileReader()
      //   reader.onloadend = function() {
      //     const arrays = []
      //     const uint8Array = new Uint8Array(reader.result)
      //     for (const uint of uint8Array) {
      //       arrays.push(uint)
      //     }
      //     resolve(arrays)
      //     reader.abort()
      //   }
      //   reader.readAsArrayBuffer(file)
      // })
      //
      // const bytes = await arrayPromise
      //
      // this.invoice.File = {
      //   Name: file.name,
      //   ByteData: bytes
      // }

    }
  },
  watch: {
    importers(importers) {
      this.keys['Importer.Id'].attrs.items = importers
    },
    products(products) {
      this.keys['Product.Id'].attrs.items = products
    },
    'invoice.TotalUs'(total) {
      this.invoice.TotalUsWords = num2str(total)
    },
    'invoice.QuantityTons'(quantity) {
      this.invoice.TotalUs = (quantity * this.invoice?.PricePerTon)
    },
    'invoice.PricePerTon'(perTon) {
      this.invoice.TotalUs = (perTon * this.invoice?.QuantityTons)
    }
  }
}
</script>